import { CommonSlice } from './reducer';
import { checkTestEvent, createTestEvent, deleteTestEvent } from './services';
import { RETCODE_SUCCESS, RETTEXT_SUCCESS } from '@configs/contants';
import { message } from 'antd';

export const { setLanguage, setPinCode, setStatusTesting, setLoading } = CommonSlice.actions;

export const onSetLanguage = (lang) => async (dispatch) => {
  dispatch(setLanguage(lang));
};

export const onSetPinCode = (payload) => async (dispatch) => {
  dispatch(setPinCode(payload));
};

export const onSetStatusCheckEvent = (payload) => async (dispatch) => {
  dispatch(setStatusTesting(payload));
};

export const onCreateTestEvent = (payload) => async (dispatch) => {
  try {
    setLoading(true);
    const res = await createTestEvent(payload);
    if (res.retCode !== RETCODE_SUCCESS) {
      message.error(res?.retText);
      return;
    }
    if (!!res.data) {
      dispatch(setStatusTesting(res.data));
    }
  } catch (err) {
    dispatch(setLoading(err));
    throw new Error(err);
  } finally {
    dispatch(setLoading(true));
  }
};

export const onCheckTestEvent = (eventId) => async (dispatch) => {
  try {
    setLoading(true);
    const res = await checkTestEvent(eventId);
    if (res.retCode !== RETCODE_SUCCESS) {
      message.error(res?.retText);
      return;
    }
    if (!!res.data) {
      dispatch(setStatusTesting(res.data));
    }
  } catch (err) {
    dispatch(setLoading(err));
    throw new Error(err);
  } finally {
    dispatch(setLoading(true));
  }
};

export const onDeleteTestEvent = (payload) => async (dispatch) => {
  try {
    setLoading(true);
    const res = await deleteTestEvent(payload);
    if (res.retCode !== RETCODE_SUCCESS) {
      message.error(res?.retText);
      return;
    }
    dispatch(setStatusTesting(undefined));
  } catch (err) {
    dispatch(setLoading(err));
    throw new Error(err);
  } finally {
    dispatch(setLoading(true));
  }
};

export const getToken = () => {
  return localStorage.getItem('accessToken') || sessionStorage.getItem('accessToken');
}
